import * as React from "react";
import { useNavigate } from "react-router-dom";

export default function Subscriber({
    email,
    isUser,

}) {
    const navigate = useNavigate();
    return (
        <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li
                style={{
                    padding: '15px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    borderRadius: '8px',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                }}
            >
                <div style={{ fontWeight: 'bold', }}>{email}</div>
            </li>
        </ul>
    );
}